export * from './corporate-permission.dto';
